import React from 'react';
import RewardsProgramFeature from './RewardsProgramFeature';
import uniqueId from 'lodash.uniqueid';

var RewardsProgramFeatureList = function RewardsProgramFeatureList(props) {
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model;
  var id = uniqueId();
  var _model$FeatureList = model.FeatureList,
      FeatureList = _model$FeatureList === void 0 ? [] : _model$FeatureList;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-rewards-program-feature-list"
  }, FeatureList.map(function (feature, index) {
    return /*#__PURE__*/React.createElement(RewardsProgramFeature, {
      key: "reward-program-feature-".concat(id, "-").concat(index),
      index: index,
      model: feature.fields
    });
  }));
};

export default RewardsProgramFeatureList;